module.exports={
    "两次输入的密码必须一致": "Les mots de passe ne correspondent pas",
    "取消": "Annuler",
    "如验证出现问题，请点击": "Si une erreur de vérification survient, veuillez cliquer ici",
    "如验证出现问题，请联系orcalivecs@asiainnovations.com": "Si une erreur de vérification survient, veuillez contacter orcalivecs@asiainnovations.com",
    "如验证出现问题，请联系upcs@asiainnovations.com": "Si une erreur de vérification survient, veuillez contacter upcs@asiainnovations.com",
    "密码修改成功": "Le mot de passe a été modifié avec succès",
    "密码格式错误": "Mauvais format de mot de passe",
    "密码由6-20位由数字和字母组成": "Le mot de passe doit contenir 6 à 20 caractères,y compris lettres et nombres",
    "恭喜您密码重置成功": "Mot de passe réinitialisé avec succès",
    "恭喜您已成功激活帐户": "Votre compte est bien activé",
    "知道了": "D'accord",
    "确认修改": "Confirmer la modification",
    "网络连接有误, 请稍后再试": "Problème de connexion, veuillez réessayer plus tard",
    "联系客服": "Contacter le service client",
    "请再次输入密码": "Confirmer le mot de passe",
    "请返回UpVoice中重新进行邮箱验证": "Retour à UpVoice pour vérification d'email",
    "请返回Up直播中重新进行邮箱验证": "Retour à Uplive pour vérification d'email",
    "请返回虎鲸直播中重新进行邮箱验证": "Retour à Orcalive pour vérification d'emaill",
    "请重新设定登录密码": "Réinitialiser le mot de passe",
    "请重新设置密码": "Réinitialiser le mot de passe",
    "赶快返回UpVoice中与全球潮人互动吧": "Retour à UpVoice, et faisons la fête",
    "赶快返回Up直播中与全球潮人互动吧！": "Retour à Uplive, et faisons la fête!",
    "赶快返回虎鲸直播中与全球潮人互动吧": "Retour à Orcalive, et faisons la fête",
    "重置密码失败": "Impossible de réinitialiser le mot de passe",
    "验证失败": "Échec de la vérification",
    "验证成功": "Vérification réussie"
};


// WEBPACK FOOTER //
// ./js/lang/frfr.js